exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payroll-loans-page .app-main{background-color:#fff;padding:5rem 0 0 0 !important}.payroll-loans-page .content iframe.template-portal{width:100%;height:100%;height:100vh}.payroll-loans-page .navbar{display:block !important}.payroll-loans-page .ng-hide{display:block !important}", ""]);

// exports
